import React from 'react';
import Icon from '../atoms/Icon';

function HistoryIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <g fill='none' fillRule='evenodd' stroke='currentColor' stroke-width='2.63636' stroke-miterlimit='10'>
        <path d='M2.30681 10.5454C4.4159 5.14486 9.67018 1.31818 15.8182 1.31818C23.8261 1.31818 30.3182 7.81022 30.3182 15.8182C30.3182 23.8261 23.8261 30.3182 15.8182 30.3182C7.81022 30.3182 1.31818 23.8261 1.31818 15.8182'/>
        <path d='M15.8182 5.27274V15.8182H23.7273'/>
        <path d='M9.22727 10.5454H1.31818V2.63635'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(HistoryIcon);
